import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "Finance Foundations & Money Management Basics",
    description:
      "money inflation & interest rates, Types of financial markets, Difference between assets liabilities & equity, Importance of financial literacy in modern careers",
  },
  {
    title: "Financial Accounting & Statement Analysis",
    description:
      "Basics of accounting: debit credit journal entries, Understanding Balance Sheet P&L Cash Flow, Ratio analysis: liquidity profitability & solvency ratios, Real-world company case study evaluation, Red flags in financial statements",
  },
  {
    title: "Corporate Finance & Capital Budgeting",
    description:
      "Cost of capital (WACC), Capital budgeting techniques: NPV IRR Payback, Capital structure & financing decisions, Dividend policy & working capital management, How companies make investment decisions",
  },
  {
    title: "Investment Management & Wealth Building",
    description:
      "Stocks bonds mutual funds ETFs, Portfolio management basics, SIP asset allocation & diversification, Risk-return concepts, Building long-term wealth strategies",
  },
  {
    title: "Banking, Financial Institutions & FinTech Innovations",
    description:
      "Role of banks & NBFCs, Loan types credit system & interest mechanisms, Digital payments UPI crypto & blockchain basics, FinTech revolution in India & global markets, Future of digital banking",
  },
  {
    title: "Financial Markets, Trading & Market Instruments",
    description:
      "Understanding stock bond & commodity markets, Market players: Retail FIIs DIIs, Derivatives basics: futures options & hedging, Market cycles volatility & macroeconomic impact, How trading platforms work",
  },
  {
    title: "Taxation, Budgeting & Financial Planning",
    description:
      "Income tax basics & tax-saving instruments, GST overview for beginners, Budgeting methods: zero-based 50-30-20 rule, Emergency funds & retirement planning, Goal-based financial planning",
  },
  {
    title: "Risk Management, Insurance & Fraud Prevention",
    description:
      "Types of financial risks (market credit operational), Risk mitigation strategies, Insurance types: health life general, Identifying fraud scams & financial misconduct, Corporate governance & internal controls",
  },
  {
    title: "Excel, Financial Modeling & Analytical Tools",
    description:
      "Excel functions for finance (VLOOKUP PMT NPV IRR), Building financial models, Forecasting & budgeting through spreadsheets, Dashboards & visual financial reports, Intro to Python for finance analytics (optional)",
  },
  {
    title: "Capstone Finance Project & Career Launchpad",
    description:
      "Analyze a company & build a financial report, Create a complete investment plan, Portfolio presentation & cash flow forecasting, Resume & LinkedIn optimization for finance roles, Interview prep for Analyst Finance Manager Investment Advisor",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
